import React, { useEffect, useState } from "react";
import BaseModal from "../BaseModal";
import { getDDMMYY, getDateMMYY, slashToHyphenDate } from "../../../../Helpers";
import { editCuratedFile, getReportTypes } from "../../../../Services";
import Button from "../../Buttons/Button";
import "./style.css";
import Dropdown from "../../Dropdown";
import { usePatientContext } from "../../../../Context/PatientContext";

/**
 * Modal for Viewing Patient Record
 * @param {function} onClose - Function to handle the modal close event
 */

const ViewReportModal = ({
  screen,
  type,
  report,
  reportURL,
  onClose,
  fields,
  patientId,
  physicianId,
}) => {
  // console.log(fields, "fields");

  const { patientDetails, updatePatientDetails } = usePatientContext();

  const [editMode, setEditMode] = useState(false);
  const [reportTypeKeys, setReportTypeKeys] = useState([]);
  const [currentReportType, setCurrentReportType] = useState(report.reportType);
  const [formData, setFormData] = useState({
    ...fields,
    impression: report?.impression,
    commentsOrg:
      report?.commentsOrg && report?.commentsOrg.length > 0
        ? report?.commentsOrg[report?.commentsOrg?.length - 1]
        : "",
    date:
      (fields[report?.reportType?.reportType?.schemaVariable] &&
        fields[report?.reportType?.reportType?.schemaVariable]["date"]) ||
      (fields[report?.reportType?.reportType?.schemaVariable] &&
        fields[report?.reportType?.reportType?.schemaVariable]["startDate"]) ||
      report.reportDate,
  });
  const [addMore, setAddMore] = useState(false);
  const [addMoreOptions, setAddMoreOptions] = useState(false);
  const [addMoreFieldTypes, setAddMoreFieldTypes] = useState([]);
  const [selectedMoreFieldType, setSelectedMoreFieldType] = useState({});
  const [moreFieldTypes, setMoreFieldTypes] = useState([]);
  const [moreFieldTypesInReport, setMoreFieldTypesInReport] = useState([]);

  // custom compare function for sorting
  const fieldTypesCompare = (a, b) => {
    if (a.reportType.name < b.reportType.name) {
      return -1;
    }
    if (a.reportType.name > b.reportType.name) {
      return 1;
    }
    return 0;
  };

  // fetch report types to get parameters and more fields to add
  const fetchReportTypes = async () => {
    try {
      const reportTypeResponse = await getReportTypes(
        physicianId,
        patientId,
        "all"
      );
      // console.log(data.data, "report types");
      if (!reportTypeResponse.error) {
        setReportTypeKeys(reportTypeResponse?.data);

        let nonReportFieldTypes = reportTypeResponse?.data?.filter(
          (type) => !type?.isReport
        );
        nonReportFieldTypes = nonReportFieldTypes.sort(fieldTypesCompare);
        setAddMoreFieldTypes(
          nonReportFieldTypes.filter(
            (type) => !formData[type?.reportType?.schemaVariable]
          )
        );
        setMoreFieldTypes(
          nonReportFieldTypes.filter(
            (type) => formData[type?.reportType?.schemaVariable]
          )
        );
        setMoreFieldTypesInReport(
          nonReportFieldTypes.filter(
            (type) => formData[type?.reportType?.schemaVariable]
          )
        );
      }
    } catch (error) {
      // throw error
    }
  };

  const handleEditReport = async () => {
    try {
      const editReportResponse = await editCuratedFile(
        physicianId,
        patientId,
        report._id,
        { updates: formData }
      );

      if (!editReportResponse.error) {
        setEditMode(false);
        updatePatientDetails({
          ...patientDetails,
          ...editReportResponse?.data?.patientResponse,
        });
      }
    } catch (error) {
      // throw error
    }
  };

  useEffect(() => {
    fetchReportTypes();
  }, []);

  useEffect(() => {
    // setCurrentReportType(
    //   reportTypeKeys.find(
    //     (report) => report._id === draftReport?.reportType?._id
    //   )
    // );
    setMoreFieldTypes([
      ...moreFieldTypesInReport,
      ...addMoreFieldTypes.filter(
        (type) => formData[type?.reportType?.schemaVariable]
      ),
    ]);
    setAddMoreFieldTypes(
      addMoreFieldTypes.filter(
        (type) => !formData[type?.reportType?.schemaVariable]
      )
    );
  }, [reportTypeKeys]);

  // console.log(currentReportType?.reportType?.schemaVariable, "formdata");
  // console.log(formData, "formdata");

  return (
    //Title & pdfurl
    <BaseModal
      title={
        screen === "table"
          ? `Date: ${getDDMMYY(report?.reportDate)} | Type: ${
              report?.reportType?.reportType?.name
            }`
          : `Date: ${
              getDDMMYY(report?.absoluteDate) || getDateMMYY(report?.startDate)
            } | Type: ${report?.eventName || report?.eventType}`
      }
      onClose={onClose}
    >
      <div className="view-report-container">
        <iframe
          title="Report PDF"
          src={reportURL}
          width="748px"
          // height="456px"
          height="100%"
        ></iframe>
        {type === "edit" && fields && (
          <div className="details-container">
            {/* Report type fields */}
            <div className="file-details-frame">
              {/* <div> */}
              {currentReportType?.parameters?.map((item, index) => {
                // get the parameter value from formdata
                let paramValue =
                  formData[currentReportType?.reportType?.schemaVariable] &&
                  formData[currentReportType?.reportType?.schemaVariable][
                    item?.schemaVariable
                  ];
                if (
                  item?.schemaVariable === "date" ||
                  item?.schemaVariable === "startDate" ||
                  item?.schemaVariable === "endDate"
                ) {
                  if (paramValue) paramValue = getDDMMYY(paramValue);
                  else {
                    paramValue = getDDMMYY(report.reportDate);
                  }
                }
                return (
                  <div
                    className={
                      editMode
                        ? "file-details-field-frame-edit-mode"
                        : "file-details-field-frame"
                    }
                    key={index}
                  >
                    <p className="p-600 dark-grey">{item?.name}</p>
                    {editMode ? (
                      item?.isValue ? (
                        <div>
                          <input
                            value={
                              paramValue && paramValue["value"]
                                ? paramValue["value"]
                                : ""
                            }
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                [currentReportType?.reportType?.schemaVariable]:
                                  {
                                    ...formData[
                                      currentReportType?.reportType
                                        ?.schemaVariable
                                    ],
                                    [item?.schemaVariable]: formData[
                                      currentReportType?.reportType
                                        ?.schemaVariable
                                    ]
                                      ? {
                                          ...formData[
                                            currentReportType?.reportType
                                              ?.schemaVariable
                                          ][item?.schemaVariable],
                                          value: e.target.value,
                                        }
                                      : {
                                          value: e.target.value,
                                        },
                                  },
                              });
                            }}
                            type={item?.inputType ? item?.inputType : "text"}
                            placeholder="Enter value here..."
                            className="field-box body1 dark-grey"
                          />
                          <input
                            value={
                              paramValue && paramValue["unit"]
                                ? paramValue["unit"]
                                : ""
                            }
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                [currentReportType?.reportType?.schemaVariable]:
                                  {
                                    ...formData[
                                      currentReportType?.reportType
                                        ?.schemaVariable
                                    ],
                                    [item?.schemaVariable]: formData[
                                      currentReportType?.reportType
                                        ?.schemaVariable
                                    ]
                                      ? {
                                          ...formData[
                                            currentReportType?.reportType
                                              ?.schemaVariable
                                          ][item?.schemaVariable],
                                          unit: e.target.value,
                                        }
                                      : {
                                          unit: e.target.value,
                                        },
                                  },
                              });
                            }}
                            type={item?.inputType ? item?.inputType : "text"}
                            placeholder="Enter unit here..."
                            className="field-box body1 dark-grey"
                            style={{ marginLeft: "10px" }}
                          />
                        </div>
                      ) : item?.inputType && item?.inputType === "date" ? (
                        <input
                          value={slashToHyphenDate(paramValue)}
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              [currentReportType?.reportType?.schemaVariable]: {
                                ...formData[
                                  currentReportType?.reportType?.schemaVariable
                                ],
                                [item?.schemaVariable]: e.target.value,
                              },
                            });
                            if (
                              item?.schemaVariable === "date" ||
                              item?.schemaVariable === "startDate"
                            ) {
                              setFormData({
                                ...formData,
                                [currentReportType?.reportType?.schemaVariable]:
                                  {
                                    ...formData[
                                      currentReportType?.reportType
                                        ?.schemaVariable
                                    ],
                                    [item?.schemaVariable]: e.target.value,
                                  },
                                date: e.target.value,
                              });
                            }
                          }}
                          type={item?.inputType ? item?.inputType : "text"}
                          placeholder="Type here..."
                          className="field-box body1 dark-grey"
                        />
                      ) : (
                        <textarea
                          value={paramValue}
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              [currentReportType?.reportType?.schemaVariable]: {
                                ...formData[
                                  currentReportType?.reportType?.schemaVariable
                                ],
                                [item?.schemaVariable]: e.target.value,
                              },
                            });
                            if (
                              item?.schemaVariable === "date" ||
                              item?.schemaVariable === "startDate"
                            ) {
                              setFormData({
                                ...formData,
                                [currentReportType?.reportType?.schemaVariable]:
                                  {
                                    ...formData[
                                      currentReportType?.reportType
                                        ?.schemaVariable
                                    ],
                                    [item?.schemaVariable]: e.target.value,
                                  },
                                date: e.target.value,
                              });
                            }
                          }}
                          type={item?.inputType ? item?.inputType : "text"}
                          placeholder="Type here..."
                          className="field-box body1 dark-grey"
                          rows={4}
                        />
                      )
                    ) : item?.isValue ? (
                      <div className="file-details-field-value-frame">
                        <div className="field-box body1 dark-grey">
                          {paramValue && paramValue["value"]
                            ? paramValue["value"]
                            : ""}
                          {paramValue && paramValue["unit"]
                            ? paramValue["unit"]
                            : ""}
                        </div>
                        <div
                          // className={
                          //   styles.report_details_field_value_frame_div
                          // }
                          style={{
                            top:
                              paramValue && paramValue["value"] && item?.bioRef
                                ? "40px"
                                : "20px",
                          }}
                        >
                          <p className="body1 medium-grey">{item.bioRef}</p>
                        </div>
                        {/* )} */}
                      </div>
                    ) : (
                      <div className="file-details-field-value-frame">
                        <div className="field-box body1 dark-grey">
                          {paramValue}
                        </div>
                        {/* {paramValue && item?.bioRef && ( */}
                        <div
                        // className={
                        //   styles.report_details_field_value_frame_div
                        // }
                        >
                          <p className="body1 medium-grey">{item.bioRef}</p>
                        </div>
                        {/* )} */}
                      </div>
                    )}
                  </div>
                );
              })}
              {/* Impressions */}
              {/* <div
                className={
                  editMode
                          ? "file-details-field-frame-edit-mode"
                          : "file-details-field-frame"
                }
              >
                <p className="p-600 dark-grey">Impressions</p>
                {editMode ? (
                  <textarea
                    value={formData["impression"]}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        impression: e.target.value,
                      });
                    }}
                    placeholder="Type here..."
                    className="field-box body1 dark-grey"
                    // style={{ width: "100%", border: "1px solid #00000029" }}
                  />
                ) : (
                  <div className="file-details-field-value-frame">
                    <div className="field-box body1 dark-grey">
                      {report?.impression}
                    </div>
                  </div>
                )}
              </div> */}
              {/* Organiser's Comments */}
              <div
                className={
                  editMode
                    ? "file-details-field-frame-edit-mode"
                    : "file-details-field-frame"
                }
              >
                <p className="p-600 dark-grey">Organiser's Comments</p>
                {editMode ? (
                  <textarea
                    value={formData["commentsOrg"]}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        commentsOrg: e.target.value,
                      });
                    }}
                    placeholder="Type here..."
                    className="field-box body1 dark-grey"
                  />
                ) : (
                  <div className="file-details-field-value-frame">
                    <div className="field-box body1 dark-grey">
                      {report?.commentsOrg?.length > 0
                        ? report?.commentsOrg[0]
                        : ""}
                    </div>
                  </div>
                )}
              </div>
              {/* Additional fields */}
              {moreFieldTypes?.map(
                (field, idx) => (
                  <div key={idx}>
                    <p className="p-600 dark-grey">{field?.reportType?.name}</p>
                    {field?.parameters?.map((item, index) => {
                      if (item?.schemaVariable !== "date") {
                        const paramValue = formData[
                          field?.reportType?.schemaVariable
                        ]
                          ? formData[field?.reportType?.schemaVariable][
                              item?.schemaVariable
                            ]
                          : "";

                        return (
                          <div
                            className={
                              editMode
                                ? "file-details-field-frame-edit-mode"
                                : "file-details-field-frame"
                            }
                            key={index}
                            // style={{ marginLeft: "10px" }}
                          >
                            <p className="p-600 dark-grey">{item?.name}</p>
                            {
                              editMode ? (
                                item?.isValue ? (
                                  <div>
                                    <input
                                      value={
                                        paramValue && paramValue["value"]
                                          ? paramValue["value"]
                                          : ""
                                      }
                                      onChange={(e) => {
                                        setFormData({
                                          ...formData,
                                          [field?.reportType?.schemaVariable]: {
                                            ...formData[
                                              field?.reportType?.schemaVariable
                                            ],
                                            [item?.schemaVariable]: formData[
                                              field?.reportType?.schemaVariable
                                            ]
                                              ? {
                                                  ...formData[
                                                    field?.reportType
                                                      ?.schemaVariable
                                                  ][item?.schemaVariable],
                                                  value: e.target.value,
                                                }
                                              : {
                                                  value: e.target.value,
                                                },
                                          },
                                        });
                                      }}
                                      type={
                                        item?.inputType
                                          ? item?.inputType
                                          : "text"
                                      }
                                      placeholder="Enter value here..."
                                      className="field-box body1 dark-grey"
                                    />
                                    <input
                                      value={
                                        paramValue && paramValue["unit"]
                                          ? paramValue["unit"]
                                          : ""
                                      }
                                      onChange={(e) => {
                                        setFormData({
                                          ...formData,
                                          [field?.reportType?.schemaVariable]: {
                                            ...formData[
                                              field?.reportType?.schemaVariable
                                            ],
                                            [item?.schemaVariable]: formData[
                                              field?.reportType?.schemaVariable
                                            ]
                                              ? {
                                                  ...formData[
                                                    field?.reportType
                                                      ?.schemaVariable
                                                  ][item?.schemaVariable],
                                                  unit: e.target.value,
                                                }
                                              : {
                                                  unit: e.target.value,
                                                },
                                          },
                                        });
                                      }}
                                      type={
                                        item?.inputType
                                          ? item?.inputType
                                          : "text"
                                      }
                                      placeholder="Enter unit here..."
                                      className="field-box body1 dark-grey"
                                      style={{ marginLeft: "10px" }}
                                    />
                                  </div>
                                ) : (
                                  <textarea
                                    value={paramValue}
                                    onChange={(e) => {
                                      setFormData({
                                        ...formData,
                                        [field?.reportType?.schemaVariable]: {
                                          ...formData[
                                            field?.reportType?.schemaVariable
                                          ],
                                          [item?.schemaVariable]:
                                            e.target.value,
                                        },
                                      });
                                    }}
                                    type={
                                      item?.inputType ? item?.inputType : "text"
                                    }
                                    placeholder="Type here..."
                                    className="field-box body1 dark-grey"
                                    rows={4}
                                  />
                                )
                              ) : item?.isValue ? (
                                <div className="file-details-field-value-frame">
                                  <div className="field-box body1 dark-grey">
                                    {paramValue && paramValue["value"]
                                      ? paramValue["value"]
                                      : ""}
                                    {paramValue && paramValue["unit"]
                                      ? paramValue["unit"]
                                      : ""}
                                  </div>
                                  {/* {paramValue &&
                                      paramValue["value"] &&
                                      item?.bioRef && ( */}
                                  <div
                                  // className={
                                  //   styles.report_details_field_value_frame_div
                                  // }
                                  >
                                    <p className="body1 medium-grey">
                                      {item.bioRef}
                                    </p>
                                  </div>
                                  {/* )} */}
                                </div>
                              ) : (
                                <div
                                  className="file-details-field-value-frame"
                                  style={
                                    {
                                      // marginBottom: "10px",
                                      // paramValue && item?.bioRef
                                      //   ? "10px"
                                      //   : "0px",
                                    }
                                  }
                                >
                                  <div className="field-box body1 dark-grey">
                                    {paramValue}
                                  </div>
                                  {paramValue && item?.bioRef && (
                                    <div
                                    // className={
                                    //   styles.report_details_field_value_frame_div
                                    // }
                                    >
                                      <p className="body1 medium-grey">
                                        {item.bioRef}
                                      </p>
                                    </div>
                                  )}
                                </div>
                              )
                              // (
                              //   <div
                              //     className="file-details-field-value-frame"
                              //
                              //     style={{
                              //       marginBottom: item?.bioRef ? "10px" : "0px",
                              //     }}
                              //   >
                              //     <div className="field-box body1 dark-grey">
                              //       {item?.isValue
                              //         ? paramValue && paramValue["value"]
                              //           ? paramValue["value"]
                              //           : ""
                              //         : paramValue}
                              //     </div>
                              //     {item?.bioRef && <p className="body1 medium-grey">{item.bioRef}</p>}
                              //   </div>
                              // )
                            }
                          </div>
                        );
                      }
                    })}{" "}
                  </div>
                )
                // }
              )}
              {editMode && (
                <div className="file-details-field-frame">
                  {!addMore ? (
                    <div className="add-more-fields-frame">
                      <Button
                        btnType="green"
                        text="Add more fields"
                        onClick={() => setAddMore(true)}
                      ></Button>
                    </div>
                  ) : (
                    <div className="add-more-fields-frame">
                      <p className="p-600 dark-grey">Add more fields</p>
                      <div className="add-more-fields-frame">
                        <Dropdown
                          options={addMoreFieldTypes}
                          selectedOption={
                            selectedMoreFieldType?.reportType?.name ||
                            "Select new field"
                          }
                          onSelect={(option) => {
                            setSelectedMoreFieldType(option);
                          }}
                          style={{ backgroundColor: "#f8f8f8" }}
                        />

                        <div className="action-buttons-frame">
                          <Button
                            btnType="green"
                            text="Add"
                            onClick={() => {
                              if (selectedMoreFieldType?.reportType?.name) {
                                setMoreFieldTypes([
                                  ...moreFieldTypes,
                                  selectedMoreFieldType,
                                ]);
                                setAddMore(false);
                                setAddMoreFieldTypes(
                                  addMoreFieldTypes.filter(
                                    (item) =>
                                      item._id !== selectedMoreFieldType._id
                                  )
                                );
                                setFormData({
                                  ...formData,
                                  [selectedMoreFieldType?.reportType
                                    ?.schemaVariable]: {
                                    ...formData[
                                      selectedMoreFieldType?.reportType
                                        ?.schemaVariable
                                    ],
                                    ["date"]: formData[
                                      currentReportType?.reportType
                                        ?.schemaVariable
                                    ]
                                      ? formData[
                                          currentReportType?.reportType
                                            ?.schemaVariable
                                        ]["date"]
                                        ? formData[
                                            currentReportType?.reportType
                                              ?.schemaVariable
                                          ]["date"]
                                        : formData[
                                            currentReportType?.reportType
                                              ?.schemaVariable
                                          ]["startDate"]
                                      : formData["date"],
                                  },
                                });
                                setSelectedMoreFieldType({});
                              } else {
                                // throw error
                              }
                            }}
                          ></Button>
                          <Button
                            btnType="cancelWithIconAtFront"
                            onClick={() => {
                              setAddMore(false);
                              setSelectedMoreFieldType({});
                              setAddMoreOptions(false);
                            }}
                          ></Button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
              {/* </div> */}
            </div>
            {!editMode ? (
              <div className="action-buttons-frame">
                <Button btnType={"edit"} onClick={() => setEditMode(true)}>
                  Edit Mode
                </Button>
              </div>
            ) : (
              <div className="action-buttons-frame">
                <Button
                  btnType={"save"}
                  onClick={async () => {
                    await handleEditReport();
                    // window.location.reload();
                    // setEditMode(false);
                  }}
                >
                  Save
                </Button>
                <Button
                  btnType="cancelWithIconAtFront"
                  onClick={() => {
                    // window.location.reload();
                    setEditMode(false);
                    setFormData({
                      ...fields,
                      impression: report?.impression,
                      commentsOrg:
                        report?.commentsOrg && report?.commentsOrg.length > 0
                          ? report?.commentsOrg[report?.commentsOrg?.length - 1]
                          : "",
                      date:
                        (fields[
                          report?.reportType?.reportType?.schemaVariable
                        ] &&
                          fields[
                            report?.reportType?.reportType?.schemaVariable
                          ]["date"]) ||
                        (fields[
                          report?.reportType?.reportType?.schemaVariable
                        ] &&
                          fields[
                            report?.reportType?.reportType?.schemaVariable
                          ]["startDate"]) ||
                        report.reportDate,
                    });
                    setMoreFieldTypes(moreFieldTypesInReport);
                  }}
                >
                  Cancel
                </Button>
              </div>
            )}
          </div>
        )}
      </div>
    </BaseModal>
  );
};

export default ViewReportModal;
